const AUTH_ERROR_CODE = 'auth_failed';
const AUTH_ERROR_EVENT_NAME = 'skf-widget-auth-error';

export function isAuthErrorPayload(message: string, body: unknown): boolean {
    if (body && typeof body === 'object') {
        const record = body as Record<string, unknown>;
        return typeof record.code === 'string' && record.code.trim() === AUTH_ERROR_CODE;
    }

    return false;
}

export function resolveAuthErrorMessage(message: string, body: unknown): string {
    if (body && typeof body === 'object') {
        const record = body as Record<string, unknown>;
        if (typeof record.message === 'string' && record.message.trim().length > 0) {
            return record.message.trim();
        }
    }

    return message;
}

export function emitAuthErrorEvent(message: string): void {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
        return;
    }

    window.dispatchEvent(
        new CustomEvent(AUTH_ERROR_EVENT_NAME, {
            detail: {
                message
            }
        })
    );
}
